import { Dispatch, SetStateAction } from "react";
import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
  RequestResult,
} from "../../lib";
import { FetchGroups } from "../../model";
import { TrendConfig, Variable } from "../../shared/analysis";

import { doREQUEST_ERROR, doREQUEST_COMPLETE } from "../state";
import { getToken } from "./token_fetcher";

export const REQUEST_ANALYTIC_GRAPH_TREND_MULTIPLE_GROUP_FETCH =
  "REQUEST_ANALYTIC_GRAPH_TREND_MULTIPLE_GROUP_FETCH";
export const doREQUEST_ANALYTIC_GRAPH_TREND_MULTIPLE_GROUP_FETCH = createDoRequestAction(
  REQUEST_ANALYTIC_GRAPH_TREND_MULTIPLE_GROUP_FETCH,
);

export const requestAnalyticGraphTrendMultipleGroupFetchActionCreators = {
  doREQUEST_ANALYTIC_GRAPH_TREND_MULTIPLE_GROUP_FETCH,
};

export function* requestAnalyticGraphTrendMultipleGroupFetch({
  payload,
  type,
  setRequestResult,
}: {
  payload: {
    requestId: string;
    groups: FetchGroups;
    yymmddIndexStart: number;
    yymmddIndexEnd: number;
    variables: Variable[];
    config?: TrendConfig;
  };
  type: string;
  setRequestResult: Dispatch<SetStateAction<RequestResult | null>>;
}): SagaIterator {
  debug("saga*requestAnalyticGraphTrendMultipleGroupFetch");

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        groups: v
          .object<FetchGroups>()
          .pattern(v.string(), v.array().items(v.string().uuid()))
          .min(2)
          .required(),
        yymmddIndexStart: v.number().required(),
        yymmddIndexEnd: v.number().required(),
        variables: v
          .array()
          .min(2)
          .max(4)
          .items(
            v
              .object({
                identifier: v.string().exist(),
              })
              .unknown(true)
              .required(),
          )
          .required(),
        config: v
          .object({
            color_discreate_sequence: v.array().items(v.string()).optional(),
          })
          .optional(),
      }),
    });
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_ANALYTIC_GRAPH_TREND_MULTIPLE_GROUP_FETCH,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    );
  }

  const { groups, yymmddIndexStart, yymmddIndexEnd, variables, config } = payload;
  const accessToken = yield call(getToken);

  const result = yield request({
    method: "post",
    url: `${API_URL}/v1/web/analytic-graph-trend-multiple-group-fetch`,
    accessToken,
    data: {
      groups,
      yymmddIndexStart,
      yymmddIndexEnd,
      variables,
      config,
    },
  });

  if (!result.success || result.error) {
    const error = result.error || new Error("request did not succeed");
    debug(error);

    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_ANALYTIC_GRAPH_TREND_MULTIPLE_GROUP_FETCH,
          fromPayload: payload,
          requestId: payload.requestId,
          url: "/v1/web/analytic-graph-trend-multiple-group-fetch",
          ...result,
          error,
        },
        setRequestResult,
      ),
    );
  }

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_ANALYTIC_GRAPH_TREND_MULTIPLE_GROUP_FETCH,
        fromPayload: payload,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  );
}

export function* analyticGraphTrendMultipleGroupFetchSaga() {
  yield takeEvery(
    REQUEST_ANALYTIC_GRAPH_TREND_MULTIPLE_GROUP_FETCH,
    requestAnalyticGraphTrendMultipleGroupFetch,
  );
}
